export const projectsData = [
  {
    image: "/nevertichu.png",
    title: "Gamebook - Nevěř tichu!",
    description:
      "Interaktivní hororová hra inspirovaná gamebookem, ve které hráč rozhoduje o osudu hlavního hrdiny.",
    website: "https://www.nevertichu.com/",
    visibility: "public",
    github: "https://www.github.com/MichaelaKrakowka/first-project",
  },
  {
    image: "/komercnicentrum.png",
    title: "Komerční centrum - Bohumín",
    description:
      "Jednostránkový web postavený v Reactu, který prezentuje služby Komerčního centra v Novém Bohumíně.  ",
    website: "https://www.komercnicentrum.com/",
    visibility: "private",
  },
];
